import { Aircraft } from "@/models/Product";

export const aircraftMock: Aircraft[] = [
  {
    id: "ac-1",
    title: "Cessna 172 Skyhawk",
    description: "Well-maintained Cessna 172 Skyhawk, perfect for training and leisure flying. Recently overhauled engine with only 200 hours SMOH.",
    price: 89000,
    images: ["https://images.unsplash.com/photo-1474302770737-173ee21bab63?w=800"],
    category: "aircraft",
    subcategory: "Single-engine aircraft",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2025-12-01",
    location: "București, România",
    status: "available",
    year: 2015,
    flightHours: 1200,
    engineType: "Lycoming IO-360",
    aircraftType: "Single-engine aircraft",
  },
  {
    id: "ac-2",
    title: "Pipistrel Virus SW 121",
    description: "Ultra-efficient ultralight aircraft. Low fuel consumption, excellent glide ratio. Perfect for cross-country flights.",
    price: 125000,
    images: ["https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=800"],
    category: "aircraft",
    subcategory: "Avioane ultrausoare (ULM)",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-11-15",
    location: "Cluj-Napoca, România",
    status: "available",
    year: 2020,
    flightHours: 350,
    engineType: "Rotax 912 ULS",
    aircraftType: "Avioane ultrausoare (ULM)",
  },
  {
    id: "ac-3",
    title: "Diamond DA42 Twin Star",
    description: "Multi-engine aircraft in excellent condition. Full glass cockpit with Garmin G1000. IFR certified.",
    price: 320000,
    images: ["https://images.unsplash.com/photo-1559628233-100c798642d4?w=800"],
    category: "aircraft",
    subcategory: "Twin-engine aircraft",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2025-10-20",
    location: "Timișoara, România",
    status: "available",
    year: 2018,
    flightHours: 800,
    engineType: "Austro Engine AE300",
    aircraftType: "Twin-engine aircraft",
  },
  {
    id: "ac-4",
    title: "AutoGyro Cavalon",
    description: "Sport gyrocopter with enclosed cabin. Rotax 914 turbo engine. Great visibility and handling.",
    price: 95000,
    images: ["https://images.unsplash.com/photo-1436491865332-7a61a109db05?w=800"],
    category: "aircraft",
    subcategory: "Gyrocopters",
    sellerId: "s3",
    sellerName: "RotorWing Romania",
    createdAt: "2025-09-10",
    location: "Brașov, România",
    status: "available",
    year: 2021,
    flightHours: 180,
    engineType: "Rotax 914 Turbo",
    aircraftType: "Gyrocopters",
  },
  {
    id: "ac-5",
    title: "Schempp-Hirth Discus-2",
    description: "High-performance standard class glider. Excellent condition with trailer included.",
    price: 62000,
    images: ["https://images.unsplash.com/photo-1464037866556-6812c9d1c72e?w=800"],
    category: "aircraft",
    subcategory: "Planoare (Gliders)",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-08-05",
    location: "Sibiu, România",
    status: "available",
    year: 2012,
    flightHours: 600,
    engineType: "N/A (Glider)",
    aircraftType: "Planoare (Gliders)",
  },
  {
    id: "ac-6",
    title: "Robinson R44 Raven II",
    description: "Light helicopter, piston engine, 4 seats. Low time, always hangared. Fresh annual inspection.",
    price: 385000,
    images: ["https://images.unsplash.com/photo-1534790566855-4cb788d389ec?w=800"],
    category: "aircraft",
    subcategory: "Helicopters",
    sellerId: "s3",
    sellerName: "RotorWing Romania",
    createdAt: "2026-01-15",
    location: "Iași, România",
    status: "available",
    year: 2019,
    flightHours: 450,
    engineType: "Lycoming IO-540",
    aircraftType: "Helicopters",
  },
];
